/* eslint-disable react-hooks/exhaustive-deps */
import { get, trim } from "lodash";
import { api } from "../app/api";
import { createContext, useEffect, useMemo, useState } from "react";
import Loader from "./Loader";

const getLanInHref = (href) => {
    const urlObject = new URL(href);
    if (urlObject.searchParams.has("lan")) {
        return urlObject.searchParams.get("lan");
    } else return undefined;
};

export const LanguageContext = createContext({});

function LanguageProvider({ children }) {
    const [languagesKeyVal, setlanguagesKeyVal] = useState({});
    const [loading, setLoading] = useState(true);

    const langCode = getLanInHref(window.location.href) || window.location.pathname.substring(1, 3);
    const localStorageKey = `translations_${langCode}`;

    const getLangData = async () => {
        try {
            const langsdata = await api.get(`language/get-key-value/${langCode}`);
            setlanguagesKeyVal(langsdata.data);
            localStorage.setItem(localStorageKey, JSON.stringify(langsdata.data));
        } catch (e) {
            console.error("Language fetch error:", e);
        } finally {
            setLoading(false);
        }
    };

    const t = (key) => {
        const v = get(languagesKeyVal, trim(key));
        return v !== undefined ? v : key;
    };

    const value = useMemo(() => ({ languagesKeyVal, t }), [languagesKeyVal]);

    useEffect(() => {
        const cached = localStorage.getItem(localStorageKey);
        if (cached) {
            try {
                const parsed = JSON.parse(cached);
                setlanguagesKeyVal(parsed);
                setLoading(false);
            } catch {}
        }
        getLangData();
    }, []);

    if (loading && Object.keys(languagesKeyVal).length === 0) {
        return <Loader />;
    }

    return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export default LanguageProvider;
